import { useTranslation } from 'react-i18next';
import { AdminPage, AdminPageHeader } from '../../components/layout/AdminPage';
import { MemberTags } from './MemberTags';
import { useAuthStore } from '../../store/auth.store';
export default function MemberTagManagementPage() {
  const { t } = useTranslation('member');
  const canRead = useAuthStore((s) => s.allowedActions?.includes('member:read'));
  return (
    <AdminPage>
      <AdminPageHeader title={t('tagEditor.title')} />
      {canRead ? (
        <>
          <p>{t('tagEditor.shared')}</p>
          <MemberTags manageOpen />
        </>
      ) : (
        <p role="alert">{t('tags.errors.TAG_ACCESS_DENIED')}</p>
      )}
    </AdminPage>
  );
}
